module.exports = __webpack_public_path__ + "static/img/bg-tr.3e247d21.png";